module.exports = __webpack_public_path__ + "img/電気回路_3_1_4.62512a74.png";